import parsePhoneNumberFromString from 'libphonenumber-js'

export const formatPhoneNumber = (number: string) => parsePhoneNumberFromString(`+${number}`)?.formatInternational() || ''
